<template>
  <div class="grid-container ma-0 pa-0">
    <div class="item1">
      <v-card class="my-5">
        <v-row align="center">
          <v-col cols="2" class="text-h5 font-weight-bold ma-5">
            {{ project.projectName }}
          </v-col>
          <v-col cols="4">
            <v-btn elevation="6" small  rounded :color="flags.contribute ? 'green' : 'deep-purple'" class="mr-2" dark @click="toggleFlags('contribute')">
              {{flags.contribute ? `Contributed` : 'Contribute'}}
              <v-icon v-if="!flags.contribute" right small color="white">mdi-puzzle-plus-outline</v-icon>
              <v-icon v-else right small color="white">mdi-check</v-icon>
            </v-btn>
            <v-btn elevation="6" small  rounded dark :color="flags.vote ? 'green' : 'deep-purple'" class="mr-2"  @click="toggleFlags('vote')">
              {{flags.vote ? `Voted` : 'Vote'}}
              <v-icon v-if="!flags.vote" small right color="white">mdi-thumb-up</v-icon>
              <v-icon v-else right small color="white">mdi-check</v-icon>
              </v-btn
            >
            <v-btn elevation="6" small  rounded dark :color="flags.invest ? 'green' : 'deep-purple'"  @click="toggleFlags('invest')">
              {{`Invest${flags.invest ? ('ed - ' + flags.invest): ''}`}}
              <v-icon v-if="!flags.invest" small right color="white">mdi-vote-outline</v-icon>
              </v-btn
            >
          </v-col>
          <v-spacer></v-spacer>
          <v-col class="mr-5" cols="1">
            <div class="text-center">
              <span class="font-weight-black text-h5">{{ flags.contribute ?project.contribute + 1 :project.contribute }}</span>
            <p class="text-body-2 mb-0">Contributors</p>
          </div>
          </v-col>
          <v-col class="mr-5" cols="1">
            <div class="text-center">
              <span class="font-weight-black text-h5">{{ flags.vote ? project.vote + 1 : project.vote }}</span>
            <p class="text-body-2 mb-0">Votes</p>
          </div>
          </v-col>
          <v-col class="mr-5" cols="1">
            <div class="text-center">
              <span class="font-weight-black text-h5">{{ project.tokens + flags.invest }}</span>
            <p class="text-body-2 mb-0">Tokens</p>
          </div>
          </v-col>
        </v-row>
      </v-card>
    </div>
    <div class="item2">
      <v-card>
        <v-app-bar elevation="0">
          <v-toolbar-title class="text-h6 pl-0">
            Project Details
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </v-app-bar>
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title>Description</v-list-item-title>
            <v-list-item-subtitle>
              {{ project.projectDetails.description }}
            </v-list-item-subtitle>
            <v-list-item-title class="mt-4"
              >Technologies Used</v-list-item-title
            >
            <v-list-item-subtitle>
              {{ project.projectDetails.technologies }}
            </v-list-item-subtitle>
            <v-list-item-title class="mt-4">Duration</v-list-item-title>
            <v-list-item-subtitle>
              {{ project.projectDetails.duration }}
            </v-list-item-subtitle>
            <v-list-item-title class="mt-4">Team Name</v-list-item-title>
            <v-list-item-subtitle>
              {{ project.projectDetails.teamName }}
            </v-list-item-subtitle>
            <v-list-item-title class="mt-4">Project journey</v-list-item-title>
            <v-list-item-subtitle>
              {{ project.projectDetails.status }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-card-actions class="mt-0 pt-0 justify-end">
          <v-list-item-action>
            <v-btn :href="project.projectDetails.download" download
              >Download Synopsis</v-btn
            >
          </v-list-item-action>
          <v-list-item-action>
            <v-btn>Project Demo</v-btn>
          </v-list-item-action>
        </v-card-actions>
      </v-card>
    </div>
    <div class="item3">
      <v-card>
        <v-app-bar elevation="0">
          <v-toolbar-title class="text-h6 pl-0">
            Team Members - {{ project.numberOfMembers }}
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn icon>
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </v-app-bar>
        <v-list three-line>
          <template v-for="(item, index) in project.teamMembers">
            <v-subheader
              v-if="item.header"
              :key="item.header"
              v-text="item.header"
            ></v-subheader>

            <v-divider
              v-else-if="item.divider"
              :key="index"
              :inset="item.inset"
            ></v-divider>

            <v-list-item v-else :key="item.title">
              <v-list-item-content>
                <v-list-item-title v-html="item.title"></v-list-item-title>
                <v-list-item-subtitle
                  v-html="item.subtitle"
                ></v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-chip>+{{ item.xp }}xp</v-chip>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-list>
      </v-card>
    </div>
    <div class="item4">
      <v-card>
        <v-app-bar elevation="0">
          <v-toolbar-title class="text-h6 pl-0">
            FeedBack / Appreciation
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn icon>
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </v-app-bar>
        <v-card elevation="0" class="px-3 my-3" v-for="(commentObj, index) in project.comments" :key="index">
          <p class="mb-0">
            <span class="mr-3 font-weight-bold text-body-1 deep-purple--text">
              {{commentObj.user}}
            </span>
            -
            <span class="ml-3 text-caption">
              {{new Date(commentObj.date).toDateString()}}
            </span>
          </p>
          <template v-if="commentObj.userLabels.length">
            <v-chip
              v-for="(userLabel, labelIndex) in commentObj.userLabels"
              :key="labelIndex"
              class="mr-2 mb-3 mt-1"
              :color="userLabelsMap[userLabel].color"
              outlined
              small
            >
              <v-icon small left>
                {{userLabelsMap[userLabel].icon}}
              </v-icon>
              {{userLabelsMap[userLabel].labelText}}
            </v-chip>
          </template>
          <p class="text-h6 font-weight-regular">{{commentObj.commentText}}</p>
          <v-divider v-if="index !== project.comments.length-1"/>
        </v-card>
        <v-textarea
          auto-grow
          outlined
          color="deep-purple"
          rows="4"
          class="mx-2 mt-6"
          v-model="feedbackMessage"
          placeholder="Add a feedback"
        ></v-textarea>
        <v-card-actions class="mt-0 pt-0 justify-end">
          <v-btn text @click="feedbackMessage = ''"> Clear </v-btn>
          <!-- <v-spacer></v-spacer> -->
          <v-btn
            class="white--text"
            color="deep-purple accent-4"
            depressed
            @click="submitComment"
          >
            Add
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  props: ["projectId"],
  computed: {
    project() {
      return this.projects[this.projectId] || this.projects[0]
    }
  },
  data() {
    return {
      flags: {
        contribute: false,
        vote: false,
        invest: 0,
      },
      projects: {
        1: {
        projectName: "FINVOTE",
        vote: 5,
        tokens: 4,
        contribute: 2,
        numberOfMembers: 4,
        projectDetails: {
          duration: "4 Months",
          status: 'Prototype',
          teamName: "Pixie Normous",
          download: "/sample.pdf",
          description:
            "Most companies have been fueled by innovation and change to develop new and competent products that can better engage customers, thereby affecting the bottom line. However, this approach has turned most innovations into a race to see who can come up with the most profitable idea, putting profit ahead of utility. When the same C-suite executive publishes a book decades later, quoting that utility should take precedence over profit, the irony is obvious. This is largely due to the fact that implementation decision-making power is concentrated in the hands of a small group.",
          technologies: "Vue JS, HTML5, CSS3",
        },
        teamMembers: [
        {
          title: "Umashankar",
          avatar: "/kiran.jpg",
          subtitle: "UI Developer",
          xp: 25,
        },
        { divider: true },
        {
          title: "Kiran",
          avatar: "/kiran.jpg",
          subtitle: "UI Developer",
          xp: 35,
        },
        { divider: true },
        {
          title: "Anvesh",
          avatar: "/kiran.jpg",
          subtitle: "UI Developer",
          xp: 55,
        },
        { divider: true },
        {
          title: "Arjun",
          avatar: "/kiran.jpg",
          subtitle: "Product Analyst",
          xp: 22,
        },
      ],
        comments: [
          {
            user: 'Kiran N',
            commentText: 'Wonderful project',
            date: "2022-04-05T08:00",
            userLabels: ["contributed", "liked"]
          },
          {
            user: 'Umashankar',
            commentText: 'Great project! Keep it up',
            date: "2022-01-05T11:00:52.345Z",
            userLabels: ["liked"]
          }
        ]
      },
      2: {
        projectName: "Bug tracker",
        vote: 2,
        tokens: 1,
        contribute: 3,
        numberOfMembers: 2,
        projectDetails: {
          duration: "8 Months",
          status: 'Prototype',
          teamName: "Outliers",
          download: "/sample.pdf",
          description:
            "This is a bug tracking application that helps identify and track bugs in projects or systems",
          technologies: "Angular, Node, REST",
        },
        teamMembers:[
        {
          title: "Gulshan",
          avatar: "/kiran.jpg",
          subtitle: "QA Automation Engineer",
          xp: 25,
        },
        { divider: true },
        {
          title: "Roopini",
          avatar: "/kiran.jpg",
          subtitle: "Associate UX Engineer",
          xp: 35,
        },{ divider: true },
        {
          title: "Viraj",
          avatar: "/kiran.jpg",
          subtitle: "UI Developer",
          xp: 35,
        },{ divider: true },
        {
          title: "Nidhi",
          avatar: "/kiran.jpg",
          subtitle: "UI Developer",
          xp: 35,
        },
      ],
        comments: [
          {
            user: 'Dhanush',
            commentText: 'Wonderful project',
            date: "2022-04-05T08:00",
            userLabels: ["liked"]
          },
          {
            user: 'Gowtham',
            commentText: 'Great project! Keep it up',
            date: "2022-01-05T11:00:52.345Z",
            userLabels: ["contributed"]
          }
        ]
      }
      },
      feedbackMessage: '',
      items: [
        {
          title: "Umashankar",
          avatar: "/kiran.jpg",
          subtitle: "UI Developer",
          xp: 25,
        },
        { divider: true },
        {
          title: "Kiran",
          avatar: "/kiran.jpg",
          subtitle: "UI Developer",
          xp: 35,
        },
        { divider: true },
        {
          title: "Anvesh",
          avatar: "/kiran.jpg",
          subtitle: "UI Developer",
          xp: 55,
        },
        { divider: true },
        {
          title: "Arjun",
          avatar: "/kiran.jpg",
          subtitle: "Product Analyst",
          xp: 22,
        },
      ],
      userLabelsMap: {
        contributed: {
          color: "indigo darken-3",
          icon: 'mdi-account',
          labelText: 'Contributor'
        },
        liked: {
          color: "success darken-3",
          icon: 'mdi-heart',
          labelText: 'Liked'
        }
      }
    };
  },
  methods: {
    submitComment() {
      this.project.comments.push({
        user: 'Kiran N',
        commentText: this.feedbackMessage,
        date: new Date(),
        userLabels: ["contributed", "liked"]
      });
      this.feedbackMessage = '';
    },
    toggleFlags(type) {
      if(type === 'invest') {
        this.flags[type] ++;
      }else {

        this.flags[type] = !this.flags[type]
      }
    }
  }
};
</script>
<style>
.grid-container {
  display: grid;
  grid-template-areas:
    "Project Project Project Project Project Project"
    "ProjectDetails ProjectDetails ProjectDetails TeamMembers TeamMembers TeamMembers"
    "FeedBack FeedBack FeedBack FeedBack FeedBack FeedBack";
  row-gap: 0;
  column-gap: 20px;
  padding: 10px;
}
.item1 {
  grid-area: Project;
}
.item2 {
  grid-area: ProjectDetails;
}
.item3 {
  grid-area: TeamMembers;
}
.item4 {
  grid-area: FeedBack;
}
.grid-container > div {
  background-color: rgba(255, 255, 255, 0.8);
  padding: 20px 0;
}
</style>
